import type { SVGProps } from "react";
export interface RankingIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RankingIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RankingIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M19.875 22v-2a.876.876 0 0 0-.875-.875h-2c-.423 0-.776.3-.857.698l-.018.177v2a1.125 1.125 0 0 1-2.25 0v-7a.875.875 0 0 0-.874-.875h-2.002a.875.875 0 0 0-.874.874V22a1.125 1.125 0 0 1-2.25 0v-4l-.018-.176A.875.875 0 0 0 7 17.125H5a.875.875 0 0 0-.875.875v4a1.125 1.125 0 0 1-2.25 0v-4A3.125 3.125 0 0 1 5 14.875h2c.304 0 .597.045.875.126v-.002a3.125 3.125 0 0 1 3.124-3.124h2.002a3.125 3.125 0 0 1 3.124 3.124V17c.278-.08.57-.125.875-.125h2c1.726 0 3.125 1.4 3.125 3.125v2a1.125 1.125 0 0 1-2.25 0"
      />
      <path
        fill={color}
        d="M22 20.875a1.125 1.125 0 0 1 0 2.25H2a1.125 1.125 0 0 1 0-2.25zM10.878 1.454a1.376 1.376 0 0 1 2.243 0l.106.177.838 1.667 1.882.27c1.103.157 1.6 1.53.756 2.34L15.353 7.2l.318 1.822c.202 1.16-1.016 1.949-1.983 1.45L11.999 9.6l-1.686.871c-.968.5-2.185-.29-1.983-1.449L8.646 7.2l-1.35-1.292c-.844-.81-.346-2.183.757-2.34l1.882-.27.838-1.667zm.803 3.38c-.165.33-.48.558-.845.61l-.672.095.473.453c.27.259.393.636.33 1.005l-.116.663.632-.326.125-.056c.295-.11.625-.09.908.056l.633.326-.116-.663c-.064-.37.06-.746.331-1.005l.472-.453-.671-.095a1.13 1.13 0 0 1-.847-.61L12 4.2l-.318.634Z"
      />
    </svg>
  );
}
